module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default w select-popper-btn",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedName || _vm.placeholder) + " "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont select-popper",
    class: {
      active: _vm.isActive
    },
    style: ({
      maxHeight: (_vm.maxHeight || 300) + 'px'
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('ul', {
    staticClass: "beautyul"
  }, [(_vm.multiple && _vm.soptions.length) ? _c('li', [_c('div', {
    staticClass: "btn-group btn-block mb10"
  }, [_c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default select-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelAll
    }
  }, [_vm._v("取消")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.soptions), function(o, index) {
    return _c('li', {
      class: {
        active: o.$isActive
      },
      on: {
        "click": function($event) {
          return _vm.selHandle(o, index)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(o[_vm.name]))]), _vm._v(" "), _c('i', {
      staticClass: "fa"
    })])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.soptions.length),
      expression: "!soptions.length"
    }],
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t暂无数据\n\t\t\t")])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@12.1.0/~/vue-loader/lib/template-compiler?{"id":"data-v-5964ba53"}!./~/.store/vue-loader@12.1.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/kxSelectPopper/kxSelect.vue
// module id = 918
// module chunks = 76